module.exports = __webpack_public_path__ + "static/media/success.ba8c1465.png";